
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Users, Share2, Star } from "lucide-react";

interface ProfileStatsProps {
  stats: {
    total_floor_plans: number;
    total_shared_floor_plans: number;
    total_favorites: number;
    average_rating: number;
  };
}

export function ProfileStats({ stats }: ProfileStatsProps) {
  const statItems = [
    {
      title: "Plattegronden",
      value: stats.total_floor_plans,
      icon: BarChart,
    },
    {
      title: "Gedeeld",
      value: stats.total_shared_floor_plans,
      icon: Share2,
    },
    {
      title: "Favorieten",
      value: stats.total_favorites,
      icon: Star,
    },
    {
      title: "Gem. Beoordeling",
      value: stats.average_rating.toFixed(1),
      icon: Users,
    },
  ];

  return (
    <div className="grid gap-4 md:grid-cols-4">
      {statItems.map((item) => (
        <Card key={item.title}>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">{item.title}</CardTitle>
            <item.icon className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{item.value}</div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
